import { useAppSelector } from "../redux/hooks";
import ROLES from "./roles";

export const useUserRole = () => {
    const selectedGroup = useAppSelector((state) => state.selectedGroup.data);
    const role = selectedGroup?.role;
    const storageRole = localStorage.getItem('role') || '';

    return {
        isMentor: role === 'mentor',
        isMentee: role === 'mentee',
        isAdmin: role === 'admin' || storageRole === ROLES.platAdmin,
        role,
    };
};
